import deleteDataById from 'actions/base/deleteDataById'
import getCollection from './getCollection'

const deleteGroup = async (id) => deleteDataById(id, getCollection)

export default deleteGroup
